<template>
<div class="chapter">
<div class="inner_page">
<h2>L'istesso tempo To My First Grandson Joslyn Stanton Baum</h2>
<p class="img"><img alt="L'istesso tempo To My First Grandson Joslyn Stanton Baum" class="calibre13" id="id-4062345538818052915" src="Images/img0002.png"/></p>
<p class="img"><img alt="image not available" class="calibre13" id="id-6865867600230270519" src="Images/img0003.png"/></p>
<p class="calibre16">To my readers: Well, my dears, here is what you have asked for: another
"Oz Book" about Dorothy's strange adventures. Toto is in this story,
because you wanted him to be there, and many other characters which you
will recognize are in the story, too. Indeed, the wishes of my little
correspondents have been considered as carefully as possible, and if the
story is not exactly as you would have written it yourselves, you must
remember that a story has to be a story before it can be written down,
and the writer cannot change it much without spoiling it.</p>
<p class="calibre16">In the preface to "Dorothy and the Wizard in Oz" I said I would like to
write some stories that were not "Oz" stories, because I thought I had
written about Oz long enough; but since that volume was published I have
been fairly deluged with letters from children imploring me to "write
more about Dorothy," and "more about Oz," and since I write only to
please the children I shall try to respect their wishes.</p>
<p class="calibre16">There are some new characters in this book that ought to win your love.
I'm very fond of the shaggy man myself, and I think you will like him,
too. As for Polychrome—the Rainbow's Daughter—and stupid little
Button-Bright, they seem to have brought a new element of fun into these
Oz stories, and I am glad I discovered them. Yet I am anxious to have
you write and tell me how you like them.</p>
<p class="calibre16">Since this book was written I have received some very remarkable news
from The Land of Oz, which has greatly astonished me. I believe it will
astonish you, too, my dears, when you hear it. But it is such a long and
exciting story that it must be saved for another book—and perhaps that
book will be the last story that will ever be told about the Land of Oz.</p>
<p class="r">L Frank Baum.</p>
<p class="calibre16"><i class="calibre17">Coronado, 1909.</i></p>
<p class="img"><img alt="image not available" class="calibre7" id="id-435149790572363133" src="Images/img0005.png"/></p>
<div>
<p class="img"><img alt="image not available" class="calibre18" id="id-7175611610100511981" src="Images/img0006.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?d82ad7ce